import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import * as generic from "@/store/generic/mutations/result-status.js";

import {
  GET_ACADEMICPERIOD,
  GET_ACADEMICPERIODS,
  ADD_ACADEMICPERIOD,
  UPDATE_ACADEMICPERIOD,
  DELETE_ACADEMICPERIOD
} from '@/queries/modules/common-data/academic-period.js';

//
// initial state
const state = {
  academicPeriod: {
    id: '',
    periodCode: '',
    year: '',
    semester: '',
  },
  academicPeriods: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: generic.clearError,
  setError: generic.setError,
  setSuccess: generic.setSuccess,
  setProcessing: generic.setProcessing,

  setAcademicPeriods: (state, payload) => {
    state.academicPeriods = payload ? payload : [];
  },
  setAcademicPeriod: (state, payload) => {
    state.academicPeriod = payload;
  },
};

//
// actions
const actions = {
  getAcademicPeriods: async ({commit}) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          query: GET_ACADEMICPERIODS,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.academicPeriod;
      } else {
        commit('setAcademicPeriods', data.getAcademicPeriods);
        commit('setSuccess', null);
        return data.getAcademicPeriods
      }

    } catch (e) {
      commit('setError', error(e));
      return {status: {success: false, error: true, message: "", full: e}};
    }

  },
  getAcademicPeriod: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          query: GET_ACADEMICPERIOD,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.academicPeriod;
      } else {
        commit('setAcademicPeriod', data.getAcademicPeriod);
        commit('setSuccess', null);
        return data.getAcademicPeriod
      }

    } catch (e) {
      commit('setError', error(e));
      return {status: {success: false, error: true, message: "", full: e}};
    }

  },
  addAcademicPeriod: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          mutation: ADD_ACADEMICPERIOD,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return null;
      } else {
        const academicPeriods = [...state.academicPeriods];
        academicPeriods.push(data.addAcademicPeriod);
        commit('setAcademicPeriods', academicPeriods);
        commit('setSuccess', newItemSuccess(data.addAcademicPeriod.periodCode));

        return data.addAcademicPeriod
      }

    } catch (e) {
      commit('setError', error(e));
      return null;
    }

  },
  updateAcademicPeriod: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          mutation: UPDATE_ACADEMICPERIOD,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return null;
      } else {
        const index = state.academicPeriods.findIndex(item => item.id === data.updateAcademicPeriod.id);
        const academicPeriods = [
          ...state.academicPeriods.slice(0, index),
          data.updateAcademicPeriod,
          ...state.academicPeriods.slice(index + 1)
        ];
        commit('setAcademicPeriods', academicPeriods);
        commit('setSuccess', updateItemSuccess(data.updateAcademicPeriod.periodCode));

        return data.updateAcademicPeriod
      }

    } catch (e) {
      commit('setError', error(e));
      return null;
    }

  },
  deleteAcademicPeriod: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          mutation: DELETE_ACADEMICPERIOD,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return null;
      } else {
        const index = state.academicPeriods.findIndex(item => item.id === data.deleteAcademicPeriod.id);
        const academicPeriods = [
          ...state.academicPeriods.slice(0, index),
          ...state.academicPeriods.slice(index + 1)
        ];
        commit('setAcademicPeriods', academicPeriods);
        commit('setSuccess', deleteItemSuccess(data.deleteAcademicPeriod.periodCode));

        return data.updateAcademicPeriod
      }

    } catch (e) {
      commit('setError', error(e));
      return null;
    }

  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
